module.exports = __webpack_public_path__ + "img/averageScore.6892961c.svg";